import { IconButton as IconButton_ } from "@chakra-ui/react"
import { forwardRef } from "react"
export const IconButton = forwardRef(({ ...props }, ref) => {
    return <IconButton_ ref={ref} {...props}>{props?.children}</IconButton_>
});